/**
 * Цихловые — 2 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const ЦИХЛОВЫЕ = [
    // ── Наши воды ──
    {
        id: 'tilapia',
        семейство: 'цихловые',
        latin: 'Oreochromis niloticus',
        повадка: 'стайная_бель',
        minKg: 0.1,
        maxKg: 3,
        typicalKg: 0.5,
        typicalLengthM: 0.28,
        depthM: 1.5,
        depthBandM: 1.5,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 14, опт: 28, макс: 36 },
        течение: 'стоячая',
        держится: ['трава', 'ил', 'коряги'],
        стая: 'большая_стая',
        нерест: { с: 5, по: 9 },
        чем: [
            { чем: 'тесто', вес: 1 },
            { чем: 'хлеб', вес: 0.8 },
            { чем: 'зелень', вес: 0.8 },
            { чем: 'пеллетс', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'кукуруза', вес: 0.6 },
            { чем: 'опарыш', вес: 0.4 },
        ],
    },
    // ── Тропики и Южное полушарие ──
    {
        id: 'peacock_bass',
        семейство: 'цихловые',
        latin: 'Cichla temensis',
        повадка: 'угонщик',
        minKg: 1,
        maxKg: 10,
        typicalKg: 3,
        typicalLengthM: 0.6,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'высокотелое',
        пасть: 'костистая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 22, опт: 29, макс: 35 },
        течение: 'слабое',
        держится: ['коряги', 'трава', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 12, по: 3 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'jig', вес: 0.8 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'spoon', вес: 0.6 },
            { чем: 'spinner', вес: 0.6 },
            { чем: 'мушка', вес: 0.6 },
        ],
    },
];
//# sourceMappingURL=cichlids.js.map